export default {
  functionKey: "MAJUSCULE",
  title: "MAJUSCULE",
  group: "Texte",
  origin: [],
  target: [],
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = ${origin}.toUpperCase();`;
    return { displayCode: code, safeCode: code };
  }
}
